import React from 'react';
import { connect } from 'react-redux';
import ManageExtrasOfferLeftNav from './left-nav';
import ManageExtrasOfferSelectProducts from './select-products';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import R from 'ramda';
import EditOffer from '../special-offers/edit-offer';
import AddSpecialOffers from '../special-offers/special-offers-wizard';
import EditExtra, { extraMissingInfo } from '../extras/edit-extra';
import AddExtra from '../extras/add-extra-wizard';
import { checkIfShouldDisable as isNewExtraFormInvalid } from '../extras/1-step-add-extra';
import uuid from 'node-uuid';
import moment from 'moment';
import debounce from 'lodash.debounce';
import { RaisedButton } from 'material-ui';

export const offerMissingInfo = offer => R.call(R.anyPass([
  () => !R.prop('offerName', offer),
  () => !R.prop('bookingCode', offer),
  () => (offer.validDatesOfSale || []).every(range => !range.fromDate),
  () => (offer.validDatesOfTravel || []).every(range => !range.fromDate),
  () => {
    if (offer.isStayPay) {
      return !(offer.daysOfWeek && offer.daysOfWeek.length) ||
        (offer.stayPays || []).some(staypay => !(staypay.maxFOC && staypay.stayDays && staypay.payDays));
    }
    const ratesEmpty = R.call(R.compose(
      R.isEmpty,
      R.reject(R.propOr('', 'notApplicable')),
      R.propOr([], 'rates')
    ), offer);
    if (!offer.rate) return true;
    if (offer.rate === 'rateAmount') return ratesEmpty;
    if (offer.rate === 'discount') return !(offer.amount && offer.discountType);
    return false;
  },
]), offer);

const ManageExtrasOffer = props => {
  const {
    data,
    offersOrExtras,
    onRequestClose,
    manageExtrasOffers,
    saving,
    RatesFormAndTable,
    contractingPeriod,
    onTextFieldChangeWithKeyPath,
    addExtraStepper,
    specialOffersStepper,
    openGlobalAlert,
  } = props;

  const processOfferForSaving = (offer, forNewOffer) => Object.assign({},
    offer, {
      validDatesOfTravel: offer.validDatesOfTravel.filter(R.either(R.prop('fromDate'), R.prop('toDate'))),
      validDatesOfSale: offer.validDatesOfSale.filter(R.either(R.prop('fromDate'), R.prop('toDate'))),
    }, offer.rate === 'rateAmount' && forNewOffer ? {
      rates: RatesFormAndTable.rates,
      rateType: RatesFormAndTable.rateType,
      nettCommission: RatesFormAndTable.nettCommission,
      commissionPercentage: RatesFormAndTable.commissionPercentage,
      nonStandardTemplateType: RatesFormAndTable.nonStandardTemplateType,
    } : {},
    forNewOffer ? { _id: `new-${uuid.v1()}` } : {},
    );
  const listToSave = offersOrExtras.list
    .filter(item => item.ratePackages.length)
    .map(item => {
      if (offersOrExtras.type === 'offers' && item._id === offersOrExtras.selectedId) {
        return processOfferForSaving(item);
      }
      return item;
    });
  const onClickDuplicate = () => {
    const foundItem = offersOrExtras.list.find(o => o._id === offersOrExtras.selectedId);
    return onTextFieldChangeWithKeyPath({
      keyPath: ['offersOrExtras', 'list'],
      value: [
        ...offersOrExtras.list,
        {
          ...foundItem,
          _id: `new-${uuid.v1()}`,
          ...(offersOrExtras.type === 'offers' ? {
            bookingCode: `${foundItem.bookingCode || ''} - Duplicated`,
          } : { extraCode: `${foundItem.extraCode || ''} - Duplicated` }),
          ratePackages: [],
        },
      ],
    });
  };
  const shouldDisableSaveBtn = (() => {
    if (offersOrExtras.type === 'offers') {
      return offersOrExtras.list.some(offer => offerMissingInfo(offer) && offer.ratePackages && offer.ratePackages.length);
    }
    return offersOrExtras.list.some(extra => extraMissingInfo(extra) && extra.ratePackages && extra.ratePackages.length);
  })();
  const onSave = () => {
    if (offersOrExtras.createNew) {
      if (offersOrExtras.type === 'offers') {
        const isNewOfferMissingATable = data.rate === 'rateAmount' && specialOffersStepper === 1;
        const newOffer = processOfferForSaving(data, true);
        const incomplete = offerMissingInfo(newOffer);
        const emptyRatePackages = !(newOffer.ratePackages && newOffer.ratePackages.length);
        if (incomplete) {
          if (isNewOfferMissingATable) {
            onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: `The new special offer is incomplete, don't forget to click on Generate Rate Table to complete the process.` });
            debounce(() => onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: '' }), 4000)();
          } else {
            openGlobalAlert({
              text: 'The new offer is incomplete, would you like to discard the new offer and save other changes?',
              onOk: () => manageExtrasOffers({ list: listToSave }),
            });
          }
        } else if (emptyRatePackages) {
          openGlobalAlert({
            text: `You haven't apply this new offer to any room types/products.`,
          });
        } else {
          manageExtrasOffers({ list: [...listToSave, newOffer] });
        }
      } else if (offersOrExtras.type === 'extras') {
        const isNewExtraMissingATable = !isNewExtraFormInvalid(data, RatesFormAndTable) && addExtraStepper === 0;
        const newExtra = {
          ...data,
          _id: `new-${uuid.v1()}`,
          rates: RatesFormAndTable.rates,
          rateType: RatesFormAndTable.rateType,
          nettCommission: RatesFormAndTable.nettCommission,
          commissionPercentage: RatesFormAndTable.commissionPercentage,
          nonStandardTemplateType: RatesFormAndTable.nonStandardTemplateType,
          taxType: RatesFormAndTable.taxType,
          currency: RatesFormAndTable.currency,
          taxInclusion: RatesFormAndTable.taxInclusion,
        };
        const incomplete = extraMissingInfo(newExtra);
        const emptyRatePackages = !(data.ratePackages && data.ratePackages.length);
        if (incomplete) {
          if (isNewExtraMissingATable) {
            onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: `The new extra is incomplete, don't forget to click on Generate Rate Table to complete the process.` });
            debounce(() => onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'error'], value: '' }), 4000)();
          } else {
            openGlobalAlert({
              text: 'The new extra is incomplete, would you like to discard the new extra and save other changes?',
              onOk: () => manageExtrasOffers({ list: listToSave }),
            });
          }
        } else if (emptyRatePackages) {
          openGlobalAlert({
            text: `You haven't apply this new extra to any room types/products.`,
          });
        } else {
          manageExtrasOffers({ list: [...listToSave, newExtra] });
        }
      }
    } else {
      manageExtrasOffers({ list: listToSave });
    }
  };
  const addNewItem = () => {
    onTextFieldChangeWithKeyPath({
      keyPath: [],
      value: {
        offersOrExtras: {
          ...offersOrExtras,
          createNew: true,
          selectedId: null,
        },
        data: {
          title: data.title,
          ratePackages: offersOrExtras.productsArray.map(o => o._id),
          ...(
            offersOrExtras.type === 'offers' ? {
              offerName: '',
              offerDetail: '',
              specialConditions: '',
              allowCombination: false,
              validDatesOfSale: [{
                fromDate: moment(new Date()).isAfter(contractingPeriod.endDate)
                  ? contractingPeriod.startDate
                  : moment.utc().startOf('day').toISOString(),
                toDate: contractingPeriod.endDate,
              }],
              validDatesOfTravel: [{}],
            } : {}
          ),
        },
      },
    });
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      {
        (offersOrExtras.list && offersOrExtras.list.length) || offersOrExtras.createNew
        ? (
            <div style={{ display: 'flex' }}>
              <ManageExtrasOfferLeftNav
                invalidCheck={offersOrExtras.type === 'offers' ? offerMissingInfo : extraMissingInfo}
                addNewItem={addNewItem}
                {...props}
              />
              <div
                style={{
                  padding: '16px',
                  width: 'calc(100% - 600px)',
                }}
              >
                {
                  !offersOrExtras.createNew && (
                    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <RaisedButton
                        label={`Duplicate this ${offersOrExtras.type === 'offers' ? 'Special Offer' : 'Extra'}`}
                        onClick={onClickDuplicate}
                      />
                    </div>
                  )
                }
                {
                  (() => {
                    if (offersOrExtras.createNew) {
                      if (offersOrExtras.type === 'offers') {
                        return <AddSpecialOffers {...props} />;
                      }
                      return <AddExtra {...props} />;
                    }
                    if (offersOrExtras.type === 'offers') {
                      return <EditOffer {...props} />;
                    }
                    if (offersOrExtras.type === 'extras') {
                      return <EditExtra {...props} />;
                    }
                  })()
                }
              </div>
              <ManageExtrasOfferSelectProducts
                {...props}
              />
            </div>
          )
        : (
          <div style={{ padding: '32px', margin: 'auto', textAlign: 'center' }}>
            There are no {data.type === 'offers' ? 'special offers' : 'extras'} to manage.
            <div>
              <FlatButton
                label="Click Here to Add One"
                secondary
                onClick={addNewItem}
              />
            </div>
          </div>
        )
      }
      <div className="flex-tc-sb" style={{ padding: '4px 8px 0px 36px', borderTop: '1px solid #e0e0e0' }}>
        <div style={{ color: '#ff4081' }}>{offersOrExtras.error}</div>
        <div>
          <FlatButton
            label="cancel"
            labelStyle={{ fontWeight: '600' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            secondary
            label="Save"
            loader={saving}
            disabled={shouldDisableSaveBtn}
            onClick={onSave}
            labelStyle={{ fontWeight: '600' }}
          />
        </div>
      </div>
    </div>
  );
};

const mapActions = ({
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
});
export default connect(null, mapActions)(ManageExtrasOffer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/manage-extras-offers/manage-extras-offers.jsx